// Same shell for the Type, Status, and Trigger selects on the Activity page,
// so the three filters read as one row of controls.
export const FILTER_SELECT_SX = {
  minWidth: 160,
  height: 40,
  fontSize: '0.8125rem',
  fontWeight: 600,
  borderRadius: 1.5,
  bgcolor: 'background.paper',
} as const
